import { CollectionAsset, CollectionFolder } from 'editor/src/store/collections/types';
import { MediaElement, MediaImage } from 'editor/src/store/design/types';
import { PluginName } from 'editor/src/store/plugins/types';

export enum CollectionDisplayOption {
  Thumbnail,
  Dropdown,
  Color,
}

export interface AdvancedPersonalisationElementData {
  folderId: string;
  displayOption: CollectionDisplayOption;
  // Ids of the assets this element offers. When set, the element shows only this subset of the
  // folder pool (per-page curation); when absent, it shows the whole folder (legacy behaviour).
  assetIds?: string[];
}

export function getAdvPersoDataFromElement(element: MediaElement): AdvancedPersonalisationElementData | undefined {
  return (
    element.type === 'image' &&
    (element.plugins?.[PluginName.AdvancedPersonalisation] || element.plugins?.[PluginName.personalizationStudio])
  );
}

export function setAdvPersoDataOnElement(
  element: Partial<MediaImage>,
  folderId: string,
  displayOption: CollectionDisplayOption,
  assetIds?: string[],
) {
  const plugins = element.plugins ? { ...element.plugins } : {};
  const data: AdvancedPersonalisationElementData = { folderId, displayOption };
  if (assetIds?.length) {
    data.assetIds = assetIds;
  }
  // TODO remove advancedPersonalizationPlugin after cleanup from apps n services.
  plugins[PluginName.AdvancedPersonalisation] = data;
  plugins[PluginName.personalizationStudio] = data;
  element.plugins = plugins;
}

// Assets an element offers: the element's curated subset (advPersoData.assetIds) resolved against
// the full folder pool, preserving folder order. Falls back to the whole folder when no subset is
// stored, so legacy elements keep showing every asset.
export function getElementCollectionAssets(
  folder: CollectionFolder,
  collectionInfo: AdvancedPersonalisationElementData,
): CollectionAsset[] {
  const { assetIds } = collectionInfo;
  if (!assetIds?.length) {
    return folder.assets;
  }
  const idSet = new Set(assetIds);
  return folder.assets.filter((asset) => idSet.has(asset.id));
}
